module.exports = __webpack_public_path__ + "img/sample-marketing.40a71587.webp";